import { createDocFromUint8Array } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { EditorContent } from '@tiptap/react';
import React from 'react';
import { useEditor } from '../../components/tiptap/hooks/useEditor';
import {
  convertYDocToJSONContent,
  getParticipantNoteExtensions,
  postProcessContent,
} from '../../components/tiptap/utils';
import { tiptapCss } from '../../theme/v3/tiptapCss';

interface Props {
  value: ReturnType<Buffer['toJSON']>;
}
const extensions = getParticipantNoteExtensions({});

export const ParticipantNoteEditorViewOnly = (props: Props) => {
  const jsonContent = React.useMemo(() => {
    const yDoc = createDocFromUint8Array(Uint8Array.from(props.value.data));
    const jsonContent = convertYDocToJSONContent(yDoc ?? {});
    const processedJsonContent = postProcessContent(jsonContent, []);
    return processedJsonContent;
  }, [props.value]);

  const { editor } = useEditor(
    {
      extensions,
      isEditable: false,
      content: jsonContent,
    },
    [jsonContent],
  );

  if (!editor) {
    return null;
  }

  return (
    <ChakraV3.Box css={tiptapCss}>
      <ChakraV3.Flex asChild>
        <EditorContent editor={editor} />
      </ChakraV3.Flex>
    </ChakraV3.Box>
  );
};
